export function arrayMove<T = any>(arr: T[], oldIndex: number, newIndex: number): T[] {
  arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
  return arr;
}
